module.exports = __webpack_public_path__ + "static/media/Catalyst.dd7cb614.svg";